import React from "react";
import { Boxes, ArrowRightLeft, Ruler, ClipboardCheck, Grid3x3, ShoppingCart, FileSignature, ListChecks } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/shared";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import CostumeInventory from "@/pages/CostumeInventory";
import Rentals from "@/pages/Rentals";
import { Measurements, AssignmentsFittings, Requirements } from "@/pages/CostumeExtras";
import { SizingSheet, SizeCharts, OrderingGuide, Agreements } from "@/pages/CostumeWorkflow";


export default function CostumeHub() {
  const { user } = useAuth();
  const role = user?.role;
  const isDirector = role === "director" || role === "owner" || role === "admin";

  if (role === "parent" || role === "dancer") {
    return (
      <div className="stagger-in">
        <PageHeader title="My Costumes" subtitle="Your dancer's rental costumes and return deadlines." testid="costume-hub-family" />
        <Rentals embedded />
      </div>
    );
  }

  return (
    <div className="stagger-in">
      <PageHeader title="Costume Hub" subtitle="One home for inventory, assignments &amp; fittings, checkout &amp; returns and measurements." testid="costume-hub-page" />
      <Tabs defaultValue="inventory" className="w-full">
        <TabsList className="bg-white rounded-full p-1 mb-6 flex-wrap h-auto">
          <TabsTrigger value="inventory" data-testid="hub-tab-inventory" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><Boxes className="w-4 h-4 mr-1.5" />Inventory &amp; Orders</TabsTrigger>
          <TabsTrigger value="assignments" data-testid="hub-tab-assignments" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><ClipboardCheck className="w-4 h-4 mr-1.5" />Assignments &amp; Fittings</TabsTrigger>
          <TabsTrigger value="checkout" data-testid="hub-tab-checkout" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><ArrowRightLeft className="w-4 h-4 mr-1.5" />Checkout &amp; Returns</TabsTrigger>
          <TabsTrigger value="sizing" data-testid="hub-tab-sizing" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><Ruler className="w-4 h-4 mr-1.5" />Sizing</TabsTrigger>
          <TabsTrigger value="charts" data-testid="hub-tab-charts" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><Grid3x3 className="w-4 h-4 mr-1.5" />Size Charts</TabsTrigger>
          <TabsTrigger value="ordering" data-testid="hub-tab-ordering" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><ShoppingCart className="w-4 h-4 mr-1.5" />Ordering Guide</TabsTrigger>
          <TabsTrigger value="agreements" data-testid="hub-tab-agreements" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><FileSignature className="w-4 h-4 mr-1.5" />Agreements</TabsTrigger>
          <TabsTrigger value="requirements" data-testid="hub-tab-requirements" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><ListChecks className="w-4 h-4 mr-1.5" />Requirements</TabsTrigger>
          <TabsTrigger value="measurements" data-testid="hub-tab-measurements" className="rounded-full data-[state=active]:bg-teal data-[state=active]:text-white"><Ruler className="w-4 h-4 mr-1.5" />Measurements</TabsTrigger>
        </TabsList>

        <TabsContent value="inventory"><CostumeInventory embedded /></TabsContent>
        <TabsContent value="assignments"><AssignmentsFittings isDirector={isDirector} /></TabsContent>
        <TabsContent value="checkout"><Rentals embedded /></TabsContent>
        <TabsContent value="sizing"><SizingSheet /></TabsContent>
        <TabsContent value="charts"><SizeCharts /></TabsContent>
        <TabsContent value="ordering"><OrderingGuide /></TabsContent>
        <TabsContent value="agreements"><Agreements /></TabsContent>
        <TabsContent value="requirements"><Requirements /></TabsContent>
        <TabsContent value="measurements"><Measurements /></TabsContent>
      </Tabs>
    </div>
  );
}
